
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/car-parts-spares-near-me",
      function () {
        return require("private-next-pages/car-parts-spares-near-me/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/car-parts-spares-near-me"])
      });
    }
  